import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { BoardMemberFormTypes } from "models/formTypes";
import { EditableTableFieldProps, FormFieldDefinitionType, FormHandles } from "models/propTypes/genericFormProps";
import { BoardMemberDetailsFormProps } from "models/propTypes/boardMemberPropTypes";
import { FormFieldConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BoardMemberDetailsForm: ForwardRefRenderFunction<FormHandles, BoardMemberDetailsFormProps> = (props, ref) => {
  return (
    <GenericForm<BoardMemberFormTypes.BoardMembers>
      formRef={ref}
      {...props}
      fields={[
        {
          label: "",
          type: FormEnums.FormSectionType.FIELDGROUPSECTION,
          innerFields: {
            boardMembers: {
              label: "",
              type: FormEnums.FormFieldType.EDITABLETABLE,
              innerFields: {
                name: {
                  label: "",
                  type: FormEnums.FormFieldType.TEXT,
                  controlLabel: TranslationKeys.Common.Name,
                },
                socialSecurityNumber: {
                  label: "",
                  type: FormEnums.FormFieldType.TEXT,
                  controlLabel: TranslationKeys.Common.PersonNumber,
                  readonly: true,
                },
                mail: {
                  label: "",
                  placeholder: " ",
                  type: FormEnums.FormFieldType.TEXT,
                  controlLabel: TranslationKeys.Common.Email,
                },
                phoneNumber: {
                  label: "",
                  type: FormEnums.FormFieldType.TEXT,
                  controlLabel: TranslationKeys.Common.Phone,
                },
                roles: {
                  label: "",
                  type: FormEnums.FormFieldType.TEXT,
                  controlLabel: TranslationKeys.Common.Roles,
                  readonly: true,
                },
              } as FormFieldDefinitionType<BoardMemberFormTypes.BoardMember>,
              extraProps: {
                idFieldKey: FormFieldConstants.BoardMember.BoardMember.SocialSecurityNumber,
                hideActions: true,
                isCompactTable: true,
                showColumnHeaders: true,
              } as EditableTableFieldProps<BoardMemberFormTypes.BoardMember>,
              className: cssExports.asSimpleTable,
            },
          } as FormFieldDefinitionType<BoardMemberFormTypes.BoardMembers>,
        },
      ]}
    />
  );
};

export default forwardRef(BoardMemberDetailsForm);
